import { Link, useLocation } from '@tanstack/react-router';
import { Card, CardContent, CardHeader, CardTitle } from '@upcaret/ui';
import { PlayCircle, ChevronDown } from 'lucide-react';
import { useState } from 'react';
import { DEMO_CONFIGS } from './config';

export function DemoSidebar() {
  const { pathname } = useLocation();
  const currentSlug = pathname?.split('/').pop()?.toLowerCase();
  const [isExpanded, setIsExpanded] = useState(false);

  // Group demos by industry
  const demosByIndustry = Object.entries(DEMO_CONFIGS).reduce(
    (acc, [slug, config]) => {
      if (!acc[config.industry]) {
        acc[config.industry] = [];
      }
      acc[config.industry].push({ slug, ...config });
      return acc;
    },
    {} as Record<
      string,
      Array<{ slug: string } & (typeof DEMO_CONFIGS)[string]>
    >,
  );

  return (
    <Card className="sticky top-4">
      <CardHeader
        className="lg:cursor-default cursor-pointer lg:pointer-events-none"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <CardTitle className="text-lg flex items-center justify-between gap-2">
          <div className="flex items-center gap-2">
            <PlayCircle className="w-5 h-5 text-primary" />
            All Demos
          </div>
          <ChevronDown
            className={`w-5 h-5 text-muted-foreground lg:hidden transition-transform ${
              isExpanded ? 'rotate-180' : ''
            }`}
          />
        </CardTitle>
      </CardHeader>
      <CardContent
        className={`space-y-6 lg:block ${isExpanded ? 'block' : 'hidden'}`}
      >
        {Object.entries(demosByIndustry).map(([industry, demos]) => (
          <div key={industry}>
            <h3 className="text-sm font-semibold text-muted-foreground mb-2">
              {industry}
            </h3>
            <ul className="space-y-1">
              {demos.map((demo) => {
                const isActive = demo.slug === currentSlug;
                return (
                  <li key={demo.slug}>
                    <Link
                      to={'/products/agent/demos/$slug/' as any}
                      params={{ slug: demo.slug }}
                      className={`block px-3 py-2 rounded-md text-sm transition-colors ${
                        isActive
                          ? 'bg-primary text-primary-foreground font-medium'
                          : 'text-muted-foreground hover:bg-muted hover:text-foreground'
                      }`}
                    >
                      {demo.title.split(' - ')[1] || demo.title}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>
        ))}
      </CardContent>
    </Card>
  );
}
